import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import projectData, {
  projectFocusOptions,
} from "../../data/projectData";
import ProjectCard from "../Projects/ProjectCards";

function FeaturedWork() {
  const proofProjects = projectData.slice(0, 6);

  return (
    <Container fluid className="featured-work-section">
      <Container className="section-shell">
        <div className="section-header section-header-left">
          <p className="section-kicker">Proof of work</p>
          <h2 className="section-title section-title-compact">
            Six builds that show the standard.
          </h2>
          <p className="section-supporting-copy section-supporting-copy-left">
            Compact proof first. Open any project if you want the fuller story.
          </p>
        </div>

        <Row className="card-grid-row g-4">
          {proofProjects.map((project) => {
            return (
              <Col md={6} lg={4} key={project.title}>
                <ProjectCard
                  {...project}
                  detailTo={`/projects/${project.slug}`}
                />
              </Col>
            );
          })}
        </Row>

        <div className="featured-work-footer">
          <Button as={Link} to="/projects">
            Browse all projects
          </Button>

          <div className="featured-work-shortcuts">
            <span className="featured-work-shortcuts-label">
              Jump straight to the closest work type:
            </span>
            <div className="featured-work-shortcuts-list">
              {projectFocusOptions
                .filter((option) => option.id !== "all")
                .map((option) => (
                  <Button
                    key={option.id}
                    as={Link}
                    to={`/projects?focus=${option.id}`}
                    variant="outline-light"
                    className="featured-shortcut-btn"
                  >
                    {option.label}
                  </Button>
                ))}
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default FeaturedWork;